<template>
<div class="chapter">
<div class="inner_page">
<div id="TOC">
<h1>Contents</h1>
<p class="noindent"><a href="#/003dedication">Dedication</a></p>
<p class="noindent" id="acknowledgments"><a href="#/004acknowledgments">Acknowledgments</a></p>
<p class="noindent" id="foreword"><a href="#/006foreword">Foreword</a></p>
<p class="noindent" id="introduction"><a href="#/007introduction">Introduction: The Road to Deliciousness</a></p>
<p class="noindent" id="ch1"><a href="#/008chapter1">01 A Short Gluten-Free Baking Primer: Know Your Ingredients and Equipment</a></p>
<p class="noindent" id="ch2"><a href="#/009chapter2">02 Cookies</a></p>
<blockquote>
<p class="noindent" id="sect3"><a href="#/009chapter2#sect_3">Speculaas</a></p>
<p class="noindent" id="sect4"><a href="#/009chapter2#sect_4">Lebkuchen</a></p>
<p class="noindent" id="sect5"><a href="#/009chapter2#sect_5">Pfeffernuesse</a></p>
<p class="noindent" id="sect6"><a href="#/009chapter2#sect_6">Springerle</a></p>
<p class="noindent" id="sect7"><a href="#/009chapter2#sect_7">Pepparkakor</a></p>
<p class="noindent" id="sect8"><a href="#/009chapter2#sect_8">Rugelach</a></p>
<p class="noindent" id="sect9"><a href="#/009chapter2#sect_9">Benne Cookies</a></p>
<p class="noindent" id="sect10"><a href="#/009chapter2#sect_10">Fortune Cookies</a></p>
<p class="noindent" id="sect11"><a href="#/009chapter2#sect_11">Mexican Wedding Cookies</a></p>
<p class="noindent" id="sect12"><a href="#/009chapter2#sect_12">Spritz Cookies</a></p>
<p class="noindent" id="sect13"><a href="#/009chapter2#sect_13">Shortbread Cookies</a></p>
<p class="noindent" id="sect14"><a href="#/009chapter2#sect_14">Candy Cane Cookies</a></p>
<p class="noindent" id="sect15"><a href="#/009chapter2#sect_15">Cutout Cookies</a></p>
<p class="noindent" id="sect16"><a href="#/009chapter2#sect_16">Thumbprint Cookies</a></p>
<p class="noindent" id="sect17"><a href="#/009chapter2#sect_17">Gingerbread Cookies</a></p>
<p class="noindent" id="sect18"><a href="#/009chapter2#sect_18">Chocolate Chip Cookies</a></p>
<p class="noindent" id="sect19"><a href="#/009chapter2#sect_19">Chocolate Chip Meringues</a></p>
<p class="noindent" id="sect20"><a href="#/009chapter2#sect_20">Meringue Mushrooms</a></p>
<p class="noindent" id="sect21"><a href="#/009chapter2#sect_21">Chocolate-Cherry Biscotti</a></p>
<p class="noindent" id="sect22"><a href="#/009chapter2#sect_22">Lemon Bars</a></p>
<p class="noindent" id="sect23"><a href="#/009chapter2#sect_23">Gingerbread House</a></p>
</blockquote>
<p class="noindent" id="ch3"><a href="#/010chapter3">03 Cakes</a></p>
<blockquote>
<p class="noindent" id="sect24"><a href="#/010chapter3#sect_24">Genoise</a></p>
<p class="noindent" id="sect25"><a href="#/010chapter3#sect_25">Bûche De Noël</a></p>
<p class="noindent" id="sect26"><a href="#/010chapter3#sect_26">Fruitcake</a></p>
<p class="noindent" id="sect27"><a href="#/010chapter3#sect_27">Cranberry Cake</a></p>
<p class="noindent" id="sect28"><a href="#/010chapter3#sect_28">Gingerbread Cake With Persimmon</a></p>
<p class="noindent" id="sect29"><a href="#/010chapter3#sect_29">Chocolate-Mandarin Cake</a></p>
<p class="noindent" id="sect30"><a href="#/010chapter3#sect_30">Orange-Scented Olive Oil Cake</a></p>
<p class="noindent" id="sect31"><a href="#/010chapter3#sect_31">King Cake</a></p>
<p class="noindent" id="sect32"><a href="#/010chapter3#sect_32">Pound Cake</a></p>
<p class="noindent" id="sect33"><a href="#/010chapter3#sect_33">Trifle</a></p>
<p class="noindent" id="sect34"><a href="#/010chapter3#sect_34">Toasted Pecan Snack Cake</a></p>
<p class="noindent" id="sect35"><a href="#/010chapter3#sect_35">Steamed Plum Pudding</a></p>
</blockquote>
<p class="noindent" id="ch4"><a href="#/011chapter4">04 Pies &amp; Tarts</a></p>
<blockquote>
<p class="noindent" id="sect36"><a href="#/011chapter4#sect_36">Pumpkin Pie</a></p>
<p class="noindent" id="sect37"><a href="#/011chapter4#sect_37">Apple-Cinnamon Pie</a></p>
<p class="noindent" id="sect38"><a href="#/011chapter4#sect_38">Maple-Pecan Pie</a></p>
<p class="noindent" id="sect39"><a href="#/011chapter4#sect_39">Chocolate-Sunflower Butter Pie</a></p>
<p class="noindent" id="sect40"><a href="#/011chapter4#sect_40">Mincemeat Tarts</a></p>
<p class="noindent" id="sect41"><a href="#/011chapter4#sect_41">Flaky Pie Crust</a></p>
</blockquote>
<p class="noindent" id="ch5"><a href="#/012chapter5">05 Breads &amp; Crackers</a></p>
<blockquote>
<p class="noindent" id="sect42"><a href="#/012chapter5#sect_42">Simple Scones</a></p>
<p class="noindent" id="sect43"><a href="#/012chapter5#sect_43">St. Lucia Buns</a></p>
<p class="noindent" id="sect44"><a href="#/012chapter5#sect_44">Applesauce Spice Muffins</a></p>
<p class="noindent" id="sect45"><a href="#/012chapter5#sect_45">Cinnamon Rolls</a></p>
<p class="noindent" id="sect46"><a href="#/012chapter5#sect_46">Dinner Rolls</a></p>
<p class="noindent" id="sect47"><a href="#/012chapter5#sect_47">Featherlight Buttermilk Biscuits</a></p>
<p class="noindent" id="sect48"><a href="#/012chapter5#sect_48">Skillet Cornbread</a></p>
<p class="noindent" id="sect49"><a href="#/012chapter5#sect_49">Soft Sandwich Bread</a></p>
<p class="noindent" id="sect50"><a href="#/012chapter5#sect_50">Date Nut Bread</a></p>
<p class="noindent" id="sect51"><a href="#/012chapter5#sect_51">Panettone</a></p>
<p class="noindent" id="sect52"><a href="#/012chapter5#sect_52">Stollen</a></p>
<p class="noindent" id="sect53"><a href="#/012chapter5#sect_53">Cheese Crackers And Straws</a></p>
<p class="noindent" id="sect54"><a href="#/012chapter5#sect_54">Stuffing Like Mama Made</a></p>
</blockquote>
<p class="noindent" id="ch6"><a href="#/013chapter6">06 Deep-Fried Treats</a></p>
<blockquote>
<p class="noindent" id="sect55"><a href="#/013chapter6#sect_55">Pumpkin Doughnuts</a></p>
<p class="noindent" id="sect56"><a href="#/013chapter6#sect_56">Sufganiyot (Jelly Doughnuts)</a></p>
<p class="noindent" id="sect57"><a href="#/013chapter6#sect_57">PIzzelles</a></p>
<p class="noindent" id="sect58"><a href="#/013chapter6#sect_58">Krumkake</a></p>
<p class="noindent" id="sect59"><a href="#/013chapter6#sect_59">Rosettes</a></p>
<p class="noindent" id="sect60"><a href="#/013chapter6#sect_60">Struffoli</a></p>
<p class="noindent" id="sect61"><a href="#/013chapter6#sect_61">Buñuelos</a></p>
<p class="noindent" id="sect62"><a href="#/013chapter6#sect_62">Cannoli</a></p>
</blockquote>
<p class="noindent" id="sourcesforingredientsequipment"><a href="#/014sourcesforingredientsequipment">Sources For Ingredients &amp; Equipment</a></p>
<p class="noindent" id="index"><a href="#/015index">Index</a></p>
<p class="noindent"><a href="#/016abouttheauthor">About the Author</a></p>
<p class="noindent"><a href="#/017copyright">Copyright</a></p>
</div>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><a id="page_7"></a><img alt="image3" src="images/image-003.jpg" width="100%"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005-toc.vue?6141fc49